module.exports = __webpack_public_path__ + "static/img/buy3x.11e95c27.png";